import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Estis somero. 
      Varmego, plenvivo, plenĝojo. 
      Maro logis per verdaj ondoj, floroj pompis, aero karesis.
    </p>

    <p class="mb-3">
      Venis aŭtuno. 
      La tempo de rezultoj, plenumiĝo de donitaj promesoj. 
      Iom ŝanĝiĝis aromoj: en ili jam estas febla nuanco de velko. 
      Ĉu rikolto aŭ forputro? 
    </p>

    <p class="mb-3">
      Oni ne scias, kio estos. 
      Simple aŭtuno.
    </p>
    `
  )
}

const itemName = {
  esp: 'Kio estis? Kio estos?',
  forLink: 'Kio estis Kio estos'
}

const item = {
  itemlink: getLink(itemName.forLink),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;